import CustomizableAvatar from "../common/CustomizableAvatar";
import MainAvatar from "../../assets/main-avatar.png";
import Smartlend from "../../assets/SMARTLEND.png";
import { Link, useNavigate } from "react-router-dom";
import { Formik, Form } from "formik";
import * as Yup from "yup";
import FormikControl from "./ReusableFormik/FormikControl";

const ForgotPassword = () => {
  const navigate = useNavigate();
  const initialValues = {
    email: "",
  };
  // validation
  const validationSchema = Yup.object({
    email: Yup.string()
      .email("Please enter a valid email address")
      .required("Required"),
  });

  //   Form submission
  const onSubmit = (values) => {
    console.log("Form data", values);
    navigate("/resetNotification");
  };

  return (
    <main className="">
      <section className="container my-0  mx-auto">
        <section>
          <div className=" p-4 px-4 md:p-8">
            <div className="grid gap-4 gap-y-2 text-sm grid-cols-1 lg:grid-cols-3">
              {/* <div className="px-4"> */}
              <CustomizableAvatar
                src={MainAvatar}
                customClass="px-1 lg:min-h-max"
              />
              {/* </div> */}
              <div className=" pl-10 lg:col-span-2">
                <CustomizableAvatar src={Smartlend} customClass={"pt-5"} />
                <p className="text-4xl font-medium py-7">Forgot Password</p>
                <p className="text-sm font-normal pb-4">
                  Enter the email address associated with this account to
                  request for password reset verification link
                </p>

                <Formik
                  initialValues={initialValues}
                  validationSchema={validationSchema}
                  onSubmit={onSubmit}
                >
                  {(formik) => {
                    return (
                      <Form className="container w-9/12">
                        <FormikControl
                          control="input"
                          label="Work email address (required)"
                          type="email"
                          placeholder="e.g. idowu.oluwatofunmi9@gmail.com"
                          name="email"
                        />

                        <button
                          type="submit"
                          className={
                            "bg-indigo-500 text-slate-50 border rounded  cursor-pointer my-7 py-1 px-16 hover:bg-indigo-600"
                          }
                          disabled={!formik.isValid}
                        >
                          Continue
                        </button>
                      </Form>
                    );
                  }}
                </Formik>

                <p>
                  Remember password?{" "}
                  <Link to={"/login"} className="text-indigo-500">
                    Login
                  </Link>
                </p>
              </div>
            </div>
          </div>
        </section>
      </section>
    </main>
  );
};

export default ForgotPassword;
